import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { saveAs } from 'file-saver';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import { PATH } from '../../../../constants/path';
import { API_ROOT, CONTEXT_ROOT } from '../../../../constants';
import { HTTP_METHOD_GET } from '../../../../constants/httpMethod';

import { isTokenExpired } from '../../../../services/authentication/utils';

import HeadComponent from '../../../HeadComponent';

const DownloadPdfComponent = ({ history, i18n, token, isAuthenticated, orderId, pdfType }) => {
    const isMemberAuthenticated = () => !isTokenExpired(token) && isAuthenticated;

    useEffect(() => {
        if (!isMemberAuthenticated()) {
            new Promise((resolve, reject) => {
                const redirectUrl = `${PATH.LOGIN_PATH}?blankRedirect=${encodeURI(
                    window.location
                )}`;
                history.push(redirectUrl);
                resolve();
            });
        } else {
            downloadPdf();
        }
    }, []);

    const downloadPdf = () => {
        if (orderId && pdfType) {
            switch (pdfType) {
                case 'codes':
                    getDownloadCodes();
                    break;
                case 'bill':
                    getDownloadBill();
                    break;
                default:
                    history.push(PATH.NOT_FOUND_PATH);
                    break;
            }
        }
    };

    const getDownload = async (uri, filename) => {
        let config = {
            credentials: 'same-origin',
            method: HTTP_METHOD_GET,
            headers: {
                Authorization: `Bearer ${token}`
            }
        };
        fetch(`${API_ROOT}${uri}`, config)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Response is incorrect');
                } else {
                    return response.blob();
                }
            })
            .then(blob => {
                var file = new Blob([blob], { type: 'application/pdf' });
                saveAs(file, filename);
            })
            .catch(function(error) {
                history.push(PATH.NOT_FOUND_PATH);
            });
    };

    const getDownloadCodes = async () => {
        await getDownload(`/ebon/order/${orderId}/export`, `mes-ebons-${orderId}.pdf`);
    };

    const getDownloadBill = async () => {
        await getDownload(`/ebon/order/${orderId}/bill`, `ma-facture-${orderId}.pdf`);
    };

    return (
        <main id="p-telechargement" className="conteneur conteneur-mobile">
            <HeadComponent
                title={i18n.TITLE}
                description={i18n.DESCRIPTION}
                canonicalLink={`${CONTEXT_ROOT}${PATH.PDF_DOWNLOAD_PATH}/${orderId}/${pdfType}`}
            />
        </main>
    );
};

DownloadPdfComponent.propTypes = {
    token: PropTypes.string,
    isAuthenticated: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
    orderId: PropTypes.string.isRequired,
    pdfType: PropTypes.string.isRequired
};

const mapStateToProps = (state, ownProps) => {
    return {
        i18n: state.i18n.page.EBON.DOWNLOAD,
        token: state.authentication.token,
        isAuthenticated: state.authentication.isAuthenticated,
        orderId: ownProps.match.params.orderId,
        pdfType: ownProps.match.params.pdfType
    };
};

export default withRouter(connect(mapStateToProps)(DownloadPdfComponent));



// WEBPACK FOOTER //
// ./src/components/pages/ebon/download/DownloadPdfComponent.js